import { FC } from 'react';
import styled from 'styled-components';

import { FCWithChildren } from 'common/types';
import * as ContentLayout from 'layouts/ContentLayout';
import { BodyProps } from 'layouts/ContentLayout';
import { SidebarProps } from 'layouts/ContentLayout/components/Sidebar';

export const { BodyScrollableSection, Root } = ContentLayout;

export const Body: FC<BodyProps> = (props) => (
  <ContentLayout.Body isScrollable={false} paddingBottom="0" {...props} />
);

export const Sidebar: FC<SidebarProps> = (props) => (
  <ContentLayout.Sidebar
    alignItems="center"
    backgroundColor="grey.100"
    justifyContent="center"
    paddingBottom="space-64"
    sx={{ '> img': { height: 256, width: 256 } }}
    {...props}
  />
);

export const SidebarWithContent: FCWithChildren = (props) => (
  <ContentLayout.Sidebar
    paddingBottom="0"
    paddingLeft="space-24"
    paddingRight="space-24"
    paddingTop="space-32"
    {...props}
  />
);

export const HeaderButtonsContainer = styled.div`
  padding-bottom: ${({ theme }) => theme.spacings.abs16}px;
  display: flex;
`;

export const FooterContainer = styled.div``;

export const FooterButtonsContainer = styled.div`
  padding: ${({ theme }) => theme.spacings.abs16}px;
  display: flex;
  justify-content: flex-end;
`;
